import { ITag } from '../..';

export interface IDeviceTags {
  poiId: string;
  tags: ITag[];
}
